// import store from '../store/store'

export default class Firm {
    constructor(rawData = {}) {
        this.id_firmy = rawData.id_firmy
        this.nazev = rawData.nazev
        this.adresa = rawData.adresa
        this.url = rawData.url
        this.logo = rawData.logo
        this.email1 = rawData.email
        this.emails = rawData.emails
        this.telefon = rawData.telefon
    }

    get getLogo() {
        if (this.logo) {
            return this.logo
        } else {
            return ''
        }
    }
}
